import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { setGlobalDeviceId } from 'src/constants/Global';

export const LONGHORN_DEVICE_ID = 'LONGHORN_DEVICE_ID';

let DEVICE_ID: string = localStorage.getItem(LONGHORN_DEVICE_ID) || '';
let deviceIdPromise: Promise<string> | null = null;

export const triggerFingerprintJS = async () => {
  const analyticsData = {
    eventName: 'FingerPrintJS',
    attributes: {
      fingerPrintBeforeFetch: Date.now(),
      fingerPrintFetched: -1
    }
  } as any;

  const fpPromise = FingerprintJS.load({
    monitoring: false
  });

  if (!DEVICE_ID) {
    const fp = await fpPromise;
    const result = await fp.get();
    const newDeviceId = result.visitorId;
    analyticsData.fingerPrintFetched = Date.now();
    setDeviceId(newDeviceId);
    return newDeviceId;

    // logError(new Error('LOG_TEST_FP'), JSON.stringify(analyticsData));
    // navigator?.sendBeacon('/events/json', analyticsData)
  }
  setGlobalDeviceId(DEVICE_ID);
  return DEVICE_ID;
};

export const waitForDeviceId = (): Promise<string> => {
  if (DEVICE_ID) return Promise.resolve(DEVICE_ID);
  if (!deviceIdPromise) {
    deviceIdPromise = triggerFingerprintJS().finally(() => {
      deviceIdPromise = null;
    });
  }
  return deviceIdPromise;
};

export const getDeviceId = (): string => {
  if (!DEVICE_ID) waitForDeviceId();
  return DEVICE_ID;
};

export const setDeviceId = (deviceId: string) => {
  if (!deviceId) return;

  DEVICE_ID = deviceId;
  localStorage.setItem(LONGHORN_DEVICE_ID, deviceId);
  setGlobalDeviceId(deviceId);
};

export const resetDeviceId = () => {
  DEVICE_ID = '';
  localStorage.setItem(LONGHORN_DEVICE_ID, DEVICE_ID);
  setGlobalDeviceId('');
};
